var VALID_APPEARANCES = ['default', 'success', 'removed', 'inprogress', 'new', 'moved'];
export var isValidAppearance = function isValidAppearance(appearance) {
  return VALID_APPEARANCES.indexOf(appearance) !== -1;
};
export var VALID_STATES = {
  open: 'inprogress',
  merged: 'success',
  declined: 'removed',
  closed: 'success',
  draft: 'inprogress',
  archived: 'default'
};
export var OMIT_STATES = ['current'];